import React from "react";

import { cv } from "~/tools/class-variance";

import type { BorgToolStatus } from "../models/borg-types";

const toolStatusVariants = cv("rounded-full px-1.5 py-0.5 text-xs", {
	defaultVariants: {
		status: "pending",
	},
	variants: {
		status: {
			pending: "bg-grey-200 text-grey-500",
			complete: "bg-green-100 text-green-700",
			failed: "bg-red-100 text-red-700",
		},
	},
});

export const ToolStatusBadge: React.FC<{ status?: BorgToolStatus }> = ({ status }) => (
	<span
		className={toolStatusVariants({
			className: undefined,
			status: status === "complete" || status === "failed" ? status : "pending",
		})}
	>
		{status ?? "pending"}
	</span>
);
